import React, { useEffect, useState } from "react";
import { useClientAuth } from "../../../utils/useAuth";
import { getHotels, getRooms } from "../../../api/client/stayoverapi";
import toast from "react-hot-toast";
import AvaibilityCalendar from "../../../components/admin/usable/AvaibilityCalendar";

const RoomAvailability = () => {
  const { company } = useClientAuth();
  const [open, setOpen] = useState(false);
  const [HotelData, setHotelData] = useState([]);
  const [RoomData, setRoomData] = useState([]);
  const [SelectedHotel, setSelectedHotel] = useState(null);
  const [SelectedRoom, setSelectedRoom] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getHotels(setHotelData, setIsLoading, company?.id);
  }, [company?.id]);
  const handleHotelChange = (e) => {
    const hotelId = e.target.value;

    setSelectedHotel(hotelId);

    if (!hotelId) {
      toast.error("Please select a hotel");
      setRoomData([]);
      return;
    }

    getRooms(setRoomData, setIsLoading, hotelId, company?.id);
  };
  const handleRoomChange = (e) => {
    const roomId = e.target.value;
    const room = RoomData.find((item) => item.id.toString() === roomId);
    if (!room) return;
    if (roomId === "") {
      setSelectedHotel("");
    }

    setSelectedRoom(room);
  };
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <div>
          <select
            name=""
            id=""
            className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
            onChange={handleHotelChange}
          >
            <option value="">Select Hotel</option>
            {HotelData.map((item) => (
              <option key={item.id} value={item.id}>
                {item.hotelName}
              </option>
            ))}
          </select>
        </div>
        <div>
          <select
            name=""
            id=""
            className="w-full px-4 py-2 rounded-lg border focus:outline-none text-sm"
            onChange={handleRoomChange}
          >
            <option value="">Select Room</option>
            {RoomData.map((item) => (
              <option key={item.id} value={item.id}>
                {item.roomName}
              </option>
            ))}
          </select>
        </div>
      </div>
      {SelectedRoom && (
        <div>
          <AvaibilityCalendar RoomInfo={SelectedRoom} />
        </div>
      )}
    </div>
  );
};

export default RoomAvailability;
